import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FormText } from "react-bootstrap"
import { FormInput } from "../../../components/forms"

const AddressInput = ({
    address,
    onEditClick
}) => {
    return <span className="d-flex row me-1">
        <FormInput
            parentClassName="col pe-0"
            className="rounded-0 rounded-start"
            value={address}
            placeholder="Address"
            disabled
        />
        <FormText
            className="col-auto border rounded-end mt-0 p-0 has-pointer d-flex align-items-center"
            onClick={onEditClick}
        >
            <FontAwesomeIcon
                className="mx-3"
                icon="pencil"
            />
        </FormText>
    </span>
}

export default AddressInput